import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { CallbackComponent } from 'redux-oidc';
import { withRouter } from 'react-router-dom';
import userManager from '../../utils/userManager';
import { resetUserCache } from 'actions/actionCreators/userActions';

class CallbackPage extends React.Component {
  render() {
    const RedirectCallback = withRouter(({ history }) => (
      <CallbackComponent
        userManager={userManager}
        successCallback={async user => {
          await this.props.actions.resetUserCache();
          const url = user.state.redirectUrl ? user.state.redirectUrl : '/';
          history.push(url);
        }}
        errorCallback={err => {
          console.error(err.message);
          history.push('/'); //temp fix (RDINC-4082)
        }}
      >
        <div>Redirecting...</div>
      </CallbackComponent>
    ));

    return <RedirectCallback />;
  }
}

CallbackPage.propTypes = {
  actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ resetUserCache }, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(CallbackPage);
